import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_SECCIONES,
  ALL_SECCIONES,
  LOADING_ALL_SECCIONES,
} from './SeccionesReducer';
import {
  deleteSeccionesService,
  allSeccionesService,
  oneSeccionesService,
  saveSeccionesService,
} from './SeccionesService';

export const allSeccionesAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_SECCIONES, payload: true });
    const res = await allSeccionesService(params);
    dispatch({ type: ALL_SECCIONES, payload: res.data });
    dispatch({ type: LOADING_ALL_SECCIONES, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_SECCIONES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveSeccionesAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveSeccionesService(id, data);
    notify(res.data.message);
    await allSeccionesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoSeccionesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_SECCIONES, payload: data });
};

export const oneSeccionesAction = async (dispatch, idEntidad, id) => {
  try {
    const res = await oneSeccionesService(idEntidad, id);
    await setActivoSeccionesAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteSeccionesAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteSeccionesService(params.idEntidad, id);
    notify(res.data.message);
    await setActivoSeccionesAction(dispatch, null);
    await allSeccionesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
